import React, { useEffect, useMemo } from "react";
import qs from "qs";
import {
  Box,
  Paper,
  Button,
  Grid,
  Badge,
  CircularProgress,
} from "@mui/material";
import "../../Features/Table/AntDesign/table.css";
import { OuterBox, InnerBox } from "../../Components/CustomBox";

import TabWithColorDashboard from "../../Features/Tabs/TabWithColorDashboard";
import BasicTabPanel from "../../Features/Tabs/BasicTabPanel";
import PageHeaderKPI from "../../Features/PageHeader/PageHeaderKPI";
import ListWithSelectionNew from "../../Features/Lists/ListWithSelectionDashboard";
import GenericSelectRedux from "../../Features/Menu/GenericSelectRedux";
import GenericSelectTest from "../../Features/Menu/GenericSelectKeyValue";
import AutocompleteDashboard from "../../Features/Autocomplete/AutocompleteDashboard";

// import DashboardContainer from "../../Features/Table/TableContainer/DashboardContainer";
import BasicTableDashboard from "../../Features/Table/AntDesign/BasicTableDashboard";
import LayersOutlinedIcon from "@mui/icons-material/LayersOutlined";
import DashboardTabs from "../../Static/Data/Dashboard/DashboardTabs";
import {
  // dashboardClickablekpis,
  dashboardNonClickablekpis,
} from "../../Static/Data/Dashboard/DashboardKPIS";
import Events from "../../Analytics/Events";
import {
  // Checkbox as AntCheckbox,
  Tooltip,
  notification,
} from "antd";
import { useDispatch, useSelector } from "react-redux";

import { getConnectedBatteries } from "../../Api/Api";
import {
  postAddToCart,
  getCartBatteries,
  getSelectAllBatteries,
} from "../../Api/CartBatteriesApi";

import {
  getAlertTypeList,
  getTableBatteries,
  // getBatteryPartnerList,
} from "../../Api/DashboardApi";
import {
  SetDashboardVolt,
  SetDashboardCategory,
  SetDashboardCity,
  SetDashboardStatus,
  SetDashboardTabValue,
  SetDashboardAlertTypeCode,
  SetDashboardAlertTypeIndex,
  SetDashboardTotal,
  SetDashboardStartDate,
  SetDashboardEndDate,
  SetDashboardStack,
  SetDashboardPageNumber,
  SetDashboardColumns,
  // SetDashboardHiddenColumns,
  SetDashboardBatteryPartnerSelect,
  SetDashboardBatteryID,
  SetDashboardDeviceID,
  SetDashboardPartner,
  SetDashboardSeverity,
  SetDashboardIOT,
  SetDashboardPack,
  DashboardExistingBatteries,
  SetDashboardZone,
  SetDashboardOpenAddSelectedBatteries,
  SetDashboardSelectedBatteriesAction,
} from "../../Actions/Dashboard";
import { SetSessionExpired } from "../../Actions";

// import { theme } from "antd";

import useState from "react-usestateref";
import { useNavigate } from "react-router-dom";
import AntDatePicker from "../../Helper/DatePicker/AntDatePicker";
import BatteriesInCart from "../../Features/Dialog/BatteriesInCart";
import { ThemeProperties } from "../../Theme/ThemeProperties";
import {
  decryptTheParams,
  encryptTheParams,
  resetTheFilterValues,
  setTheFilterValues,
} from "../../Helper/QueryParams/EncryptDecrypt";
import RemoveSelectedBatteries from "../../Features/Dialog/RemoveSelectedBatteries";
import "../../Features/Toast/NewNotification.css";
import GenericMultipleSelect from "../../Features/Menu/GenericMultipleSelect";
import {
  newCity,
  newIOT,
  newPack,
  newSeverity,
  newStatus,
  newZone,
} from "../../Static/Data/Dashboard/DashboardFilters";

import axios from "axios";
import {
  convertZonetoUTCEnd,
  convertZonetoUTCStart,
} from "../../Helper/DatePicker/DateConverter";
import { callTheAPI } from "../../Api/Functions/SettingData";
import CODE from "../../Static/Constants/StatusCodes";
import { SetRefreshAPICalled } from "../../Actions";
import { areArraysEqual } from "../../Helper/Operations/ArrayOps";

const Context = React.createContext({
  name: "Default",
});

// const { useToken } = theme;

function DashboardMain(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const { token } = useToken();

  const [api, contextHolder] = notification.useNotification();
  const openNotification = (placement, text) => {
    api.info({
      // message: `Notification ${placement}`,s
      message: <Context.Consumer>{({ name }) => `${text}`}</Context.Consumer>,
      placement,
      duration: 4.5,
      className: "antnoti",
    });
  };
  const contextValue = useMemo(
    () => ({
      name: "Toast",
    }),
    []
  );

  const universal = useSelector((state) => state.DashboardStack.arr);
  // const [selectedNewIds, setSelectNewIds] = React.useState(false);
  const orderChangedTo = useSelector((state) => state.CustomOrder.orderBy);
  const sortChangedTo = useSelector((state) => state.DashboardColumnSort.arr);

  const rowsPerPageCart = useSelector(
    (state) => state.StackTableRowsPerPage.value
  );
  const orderChangedToCart = useSelector(
    (state) => state.StackTableOrder.value
  );
  const sortChangedToCart = useSelector((state) => state.StackTableSort.value);

  const [resetButton, setResetButton] = useState(false);
  // const [existingBatteries, setExistingBatteries] = useState([]);

  const tabvalue = useSelector((state) => state.DashboardTabValue.value);
  const alertCode = useSelector((state) => state.DashboardAlertTypeCode.value);
  const total = useSelector((state) => state.DashboardTotal.value);
  const indexDashboardAlertType = useSelector(
    (state) => state.DashboardAlertTypeIndex.value
  );

  const [reduxCountItemIds, setReduxCountItemIds] = useState(0);
  const [connectedBatteries, setConnectedBatteries] = useState(0);
  const [batteries, setBatteries] = useState({
    batteries: [],
    responseStatus: { code: -1, msg: "" },
  });
  const [alertTypeList, setAlertTypeList] = useState({
    list: [],
    responseStatus: { code: -1, msg: "" },
  });
  const [listOfBatteries, setListOfBatteries] = useState({
    batteries: [],
    responseStatus: { code: -1, msg: "" },
  });

  const batteryPartnerSelect = useSelector(
    (state) => state.DashboardBatteryPartnerSelect.value
  );
  const batteryID = useSelector((state) => state.DashboardBatteryID.value);
  const deviceID = useSelector((state)=>state.DashboardDeviceID.value)
  const partner = useSelector((state) => state.DashboardPartner.value);

  const volt = useSelector((state) => state.DashboardVolt.value);
  const category = useSelector((state) => state.DashboardCategory.value);
  const city = useSelector((state) => state.DashboardCity.value);
  const batterystatus = useSelector((state) => state.DashboardStatus.value);
  const severity = useSelector((state) => state.DashboardSeverity.value);
  const iotVendor = useSelector((state) => state.DashboardIOT.value);
  const packVendor = useSelector((state) => state.DashboardPack.value);

  const zone = useSelector((state) => state.DashboardZone.value);
  const priority = "";

  const reduxStartDate = useSelector((state) => state.DashboardStartDate.value);
  const reduxEndDate = useSelector((state) => state.DashboardEndDate.value);
  // const [open, setOpen] = useState(false);
  const newColumns = useSelector((state) => state.DashboardColumns.value);

  // const columnHide = useSelector((state) => state.DashboardHiddenColumns.value);

  // const contentStyle = {
  //   backgroundColor: token.colorBgElevated,
  //   borderRadius: token.borderRadiusLG,
  //   boxShadow: token.boxShadowSecondary,
  // };
  // const menuStyle = {
  //   boxShadow: "none",
  // };
  const [cartBatteriesCount, setCartBatteriesCount] = useState(0);

  const [mounted, setMounted] = useState(false);
  const [mountedCartBatteries, setMountedCartBatteries] = useState(false);

  // const items = [
  //   ...newColumns[tabvalue]["columns"].forEach((d, i) => {
  //     if (d.name !== "")
  //       if (d.dataIndex === "batteryID" || d.dataIndex === "soc") {
  //         return {
  //           key: i + 1,
  //           label: (
  //             <AntCheckbox
  //               // color="primary"
  //               key={i + 1}
  //               checked={true}
  //               disabled
  //               // onChange={() => onFilterCheckboxClick(d.uniqueKey)}
  //             >
  //               {d.name}
  //             </AntCheckbox>
  //           ),
  //         };
  //       } else {
  //         return {
  //           key: i + 1,
  //           label: (
  //             <AntCheckbox
  //               // color="primary"
  //               key={i + 1}
  //               checked={!columnHide.includes(d.uniqueKey)}
  //               onChange={() => onFilterCheckboxClick(d.uniqueKey)}
  //             >
  //               {d.name}
  //             </AntCheckbox>
  //           ),
  //         };
  //       }
  //   }),
  // ];

  // const filters = {
  //   Volt: volt,
  //   City: city,
  //   Zone: zone,
  //   Status: batterystatus,
  //   // "Alert Type": category,
  //   Select: batteryPartnerSelect,
  //   Severity: severity,
  //   IOT: iotVendor,
  //   Pack: packVendor,
  // };

  const filters2 = {
    Severity: severity,
    Status: batterystatus,
    City: city,
    Zone: zone,
    IOT: iotVendor,
    Pack: packVendor,
  };

  // const [dashboardKPI, setDashboardKPI] = useState({
  //   operational: 0,
  //   totalLoss: 0,
  //   nonOperational: 0,
  // });

  const pageNumber = useSelector((state) => state.DashboardPageNumber.value);
  const rowsPerPage = useSelector((state) => state.DashboardRowsPerPage.value);
  const openRemoveSelectedBatteries = useSelector(
    (state) => state.DashboardOpenAddSelectedBatteries.value
  );
  const selectedBatteriesAction = useSelector(
    (state) => state.DashboardSelectedBatteriesAction.value
  );

  const [openBatteryStackDialog, setOpenBatteryStackDialog] = useState(false);
  const handleOpenBatteryStackDialog = (event) => {
    setOpenBatteryStackDialog(true);
  };
  const handleCloseBatteryStackDialog = () => {
    setOpenBatteryStackDialog(false);
  };

  // const onClickApply = () => {
  //   const tempColumns = [...newColumns];
  //   const tempHiddenColumns = [...columnHide];

  //   tempColumns[tabvalue]["columns"].forEach((column, i) => {
  //     if (column.name !== "") {
  //       if (columnHide.includes(column.uniqueKey)) {
  //         column.hidden = true;
  //         // tempHiddenColumns.push(column.uniqueKey)
  //       } else {
  //         column.hidden = false;
  //       }
  //     }
  //   });
  //   dispatch(SetDashboardColumns([...tempColumns]));
  //   // dispatch(SetDashboardHiddenColumns([...tempHiddenColumns]));
  //   setOpen(false);
  // };

  // const onClickReset = () => {
  //   const tempColumns = [...newColumns];
  //   const tempHiddenColumns = [...columnHide];

  //   tempColumns[tabvalue]["columns"].forEach((column, i) => {
  //     if (column.name !== "") {
  //       column.hidden = false;
  //       const index = tempHiddenColumns.indexOf(column.uniqueKey);
  //       if (index > -1) {
  //         // only splice array when item is found
  //         tempHiddenColumns.splice(index, 1); // 2nd parameter means remove one item only
  //       }
  //     }
  //   });
  //   // const arr = newColumns[tabvalue]["columns"];
  //   // setColumns([...arr]);
  //   dispatch(SetDashboardColumns([...tempColumns]));

  //   dispatch(SetDashboardHiddenColumns([...tempHiddenColumns]));
  //   setOpen(false);
  // };

  // const handleOpenChange = () => {
  //   setOpen(!open);
  // };

  // const onFilterCheckboxClick = (colName) => {
  //   if (columnHide.includes(colName)) {
  //     // setColumnHide([...columnHide.filter((ele) => ele != colName)]);
  //     dispatch(
  //       SetDashboardHiddenColumns([
  //         ...columnHide.filter((ele) => ele != colName),
  //       ])
  //     );
  //   } else {
  //     // setColumnHide([...columnHide, colName]);
  //     dispatch(SetDashboardHiddenColumns([...columnHide, colName]));
  //   }
  // };

  // const handleOnOpenChange = () => {
  //   const arr = [];

  //   newColumns[tabvalue]["columns"].forEach((col) => {
  //     if (col.hidden === true) {
  //       arr.push(col.uniqueKey);
  //     }
  //   });
  //   // setColumnHide([...arr])
  //   dispatch(SetDashboardHiddenColumns([...arr]));

  //   setOpen(!open);
  // };

  const ChangeTheTab = (newValue) => {
    let itemIDS = [];
    universal.forEach((item) => itemIDS.push(...item.itemIDs));

    if (itemIDS.length > 0) {
      // handleOpenRemoveSelectedBatteries();
      dispatch(SetDashboardOpenAddSelectedBatteries(true));
    } else {
      let temp;
      setMounted(false);
      setListOfBatteries({
        batteries: [],
        responseStatus: { code: -1, msg: "" },
      });
      setAlertTypeList({
        list: [],
        responseStatus: { code: -1, msg: "" },
      });
      dispatch(SetDashboardTabValue(newValue));
      dispatch(SetDashboardPageNumber(1));

      if (newValue === 0) {
        Events(`clicked Alerts Active Alerts`);
      } else if (newValue === 1) {
        Events(`clicked Alerts Open Alerts`);
      } else if (newValue === 2) {
        Events(`clicked Alerts Resolved Alerts`);
      } else if (newValue === 3) {
        Events(`clicked Alerts Ignored Alerts`);
      } else if (newValue === 4) {
        Events(`clicked Alerts Expired Alerts`);
      }
      const queryParams = decryptTheParams();
      temp = {
        ...queryParams,
        tabValue: newValue,
      };
      encryptTheParams(temp, navigate);
    }
  };

  function handleSetSelect(name, value) {
    let temp;
    const queryParams = decryptTheParams();

    temp = {
      ...queryParams,
      batteryPartnerSelect: value,
      batteryID: "",
      deviceID: "",
      partner: "",
    };
    dispatch(SetDashboardBatteryPartnerSelect(value));
    dispatch(SetDashboardBatteryID(""));
    dispatch(SetDashboardDeviceID(""));
    dispatch(SetDashboardPartner(""));
    if (batteryID !== "" || partner !== "" || deviceID!=="") resetTheFilters();

    encryptTheParams(temp, navigate);
  }
  function handleSetFilter(filterName, value) {
    setTheFilterValues(filterName, value, navigate);
    dispatch(SetDashboardPageNumber(1));

    if (filterName === "Volt") {
      dispatch(SetDashboardVolt(value));
    } else if (filterName === "Alert Type") {
      dispatch(SetDashboardCategory(value));
    } else if (filterName === "City") {
      dispatch(SetDashboardCity(value));
    } else if (filterName === "Status") {
      dispatch(SetDashboardStatus(value));
    } else if (filterName === "Zone") {
      dispatch(SetDashboardZone(value));
    } else if (filterName === "Severity") {
      dispatch(SetDashboardSeverity(value));
    } else if (filterName === "IOT") {
      dispatch(SetDashboardIOT(value));
    } else if (filterName === "Pack") {
      dispatch(SetDashboardPack(value));
    }
  }

  function resetTheFilters() {
    // dispatch(SetDashboardCategory(""));
    dispatch(SetDashboardCity(newCity));
    dispatch(SetDashboardStatus(newStatus));
    dispatch(SetDashboardSeverity(newSeverity));
    dispatch(SetDashboardZone(newZone));
    dispatch(SetDashboardIOT(newIOT));
    dispatch(SetDashboardPack(newPack));

    dispatch(SetDashboardStartDate(""));
    dispatch(SetDashboardEndDate(""));
    dispatch(SetDashboardPageNumber(1));

    resetTheFilterValues(props.pagesContent.filteredArray, navigate);
  }
  const removeSelection = () => {
    dispatch(
      SetDashboardStack([
        {
          alertCode: "sft_temp_chrg",
          alertDescription: "High temperature during charging",
          itemIDs: [],
        },
        {
          alertCode: "sft_temp_drv",
          alertDescription: "High temperature inside vehicle",
          itemIDs: [],
        },
        {
          alertCode: "sft_temp_idl",
          alertDescription: "High temperature in warehouse",
          itemIDs: [],
        },
        {
          alertCode: "sft_volt",
          alertDescription: "Over voltage protection breach",
          itemIDs: [],
        },
        {
          alertCode: "sft_cc",
          alertDescription: "Cold charging",
          itemIDs: [],
        },
        {
          alertCode: "sft_cur_chrg",
          alertDescription: "Abnormally high current during charging",
          itemIDs: [],
        },
        {
          alertCode: "sft_cur_drv",
          alertDescription: "Abnormally high current during driving",
          itemIDs: [],
        },
        {
          alertCode: "sft_cur_fluc_chrg",
          alertDescription: "High current fluctuation during charging",
          itemIDs: [],
        },
        {
          alertCode: "sft_cur_high_soc",
          alertDescription: "High current at full voltage during charging",
          itemIDs: [],
        },

        {
          alertCode: "ops_low_volt_vehicle",
          alertDescription: "Low voltage in vehicle",
          itemIDs: [],
        },
        {
          alertCode: "ops_low_volt_warehouse",
          alertDescription: "Low voltage in warehouse",
          itemIDs: [],
        },
        {
          alertCode: "ops_ml_dd",
          alertDescription: "Potential deep discharge",
          itemIDs: [],
        },
        {
          alertCode: "ops_not_ping",
          alertDescription: "Battery not pinging",
          itemIDs: [],
        },
        {
          alertCode: "vln_fc",
          alertDescription: "Field charging",
          itemIDs: [],
        },
        {
          alertCode: "vln_nc",
          alertDescription: "Night charging",
          itemIDs: [],
        },
        {
          alertCode: "vln_uc",
          alertDescription: "Unauthorised charging",
          itemIDs: [],
        },
        {
          alertCode: "vln_ufc",
          alertDescription: "Unauthorised field charging",
          itemIDs: [],
        },
        // {
        //   alertCode: "vln_ic",
        //   alertDescription: "Incomplete Charging",
        //   itemIDs: [],
        // },
      ])
    );
    dispatch(SetDashboardSelectedBatteriesAction(""));
  };
  const addToCart = () => {
    removeSelection();
    // alert("add to cart clicked")
    // Events("clicked Battries checked in");
    setBatteries({
      batteries: [],
      responseStatus: { code: -1, msg: "" },
    });

    let itemIDS = [];
    universal.forEach((item) => itemIDS.push(...item.itemIDs));

    postAddToCart(itemIDS)
      .then((res) => {
        if (res.responseStatus.code === 200) {
          // dispatch(SetDashboardStack([]));
          // window.location.reload();
        } else if (res.responseStatus.code === -2) {
          dispatch(SetSessionExpired(true));
          // window.location.reload();
        }
      })
      .then(() => {
        getCartBatteries(
          1,
          sortChangedToCart,
          orderChangedToCart,
          rowsPerPageCart
        ).then((res) => {
          let items = [];
          if (res.responseStatus.code === 200) {
            res.response.alertList.forEach((item) => {
              items.push(item.itemID);
            });
            dispatch(DashboardExistingBatteries(items));
            setBatteries({
              batteries: res.response.alertList,
              total: res.response.total.total,
              responseStatus: {
                code: res.responseStatus.code,
                msg: res.responseStatus.msg,
              },
            });
            removeSelection();
          } else {
            if (res.responseStatus.code === -2)
              dispatch(SetSessionExpired(true));

            dispatch(DashboardExistingBatteries([]));
            setBatteries({
              batteries: [],
              responseStatus: {
                code: res.responseStatus.code,
                msg: "hoi",
              },
            });
          }

          setCartBatteriesCount(items.length);
        });
      });
    dispatch(SetDashboardSelectedBatteriesAction(""));
  };

  const SetCountForCart = (type) => {
    setMountedCartBatteries(false);

    getSelectAllBatteries()
      .then((res) => {
        if (res.responseStatus.code === 200) {
          dispatch(DashboardExistingBatteries(res.response.alertList));
          setCartBatteriesCount(res.response.alertList.length);
        } else {
          if (res.responseStatus.code === -2) dispatch(SetSessionExpired(true));
          setCartBatteriesCount(0);
          dispatch(DashboardExistingBatteries([]));
        }

        setMountedCartBatteries(true);
      })
      .then(() => {
        if (type === "empty") {
          dispatch(DashboardExistingBatteries([]));
        }
      });
  };

  function changeTheDate(startDate, endDate) {
    let temp;
    const queryParams = decryptTheParams();

    // dispatch(SetDashboardAlertTypeCode(""));
    // dispatch(SetDashboardAlertTypeIndex(0));
    // dispatch(SetDashboardTotal(0));

    dispatch(SetDashboardPageNumber(1));
    if (startDate === null && endDate === null) {
      dispatch(SetDashboardStartDate(""));
      dispatch(SetDashboardEndDate(""));
      temp = {
        ...queryParams,
        startDate: "",
        endDate: "",
      };
    } else if (endDate === null) {
      dispatch(SetDashboardStartDate(startDate));
      dispatch(SetDashboardEndDate(startDate));
      temp = {
        ...queryParams,
        startDate: startDate,
        endDate: startDate,
      };
    } else if (startDate === null) {
      dispatch(SetDashboardStartDate(endDate));
      dispatch(SetDashboardEndDate(endDate));
      temp = {
        ...queryParams,
        startDate: endDate,
        endDate: endDate,
      };
    } else {
      dispatch(SetDashboardStartDate(startDate));
      dispatch(SetDashboardEndDate(endDate));
      temp = {
        ...queryParams,
        startDate: startDate,
        endDate: endDate,
      };
    }
    encryptTheParams(temp, navigate);
  }

  function getALertType() {
    let queryParams = decryptTheParams();
    alertTypeList.responseStatus.code !== -1 &&
      setAlertTypeList({
        list: [],
        responseStatus: { code: -1, msg: "" },
      });
    let obj =
      category === ""
        ? props.pagesContent.alertType.find((o) => o.itemName === "All")
        : props.pagesContent.alertType.find((o) => o.itemName === category);
    let newArr = obj.items;

    getAlertTypeList(
      tabvalue,
      volt,
      category,
      city,
      zone,
      batterystatus,
      severity,
      iotVendor,
      packVendor,
      priority,
      batteryID,
      partner,
      reduxStartDate,
      reduxEndDate,
      props.pagesContent.batteryType,
      queryParams
    ).then((res) => {
      if (res.responseStatus.code === 200) {
        let finalArr = [];
        newArr.forEach((item, index) => {
          let tempObj = res.response.alertList.find(
            (o) => o.alertCode === item.alertCode
          );
          item.alertCount = tempObj === undefined ? 0 : tempObj.alertCount;
        });

        finalArr = newArr.filter((item) => item["alertCount"] > 0);

        setAlertTypeList({
          list: finalArr,
          responseStatus: {
            code: res.responseStatus.code,
            msg: res.responseStatus.msg,
          },
        });
        if (alertCode !== "") {
          if (indexDashboardAlertType === 0) {
            if (finalArr[0]["alertCode"] !== alertCode) {
              dispatch(SetDashboardAlertTypeCode(finalArr[0]["alertCode"]));
              dispatch(SetDashboardTotal(finalArr[0]["alertCount"]));
            } else {
              dispatch(SetDashboardTotal(newArr[0]["alertCount"]));
            }
          } else {
            var result = finalArr.find((item) => item.alertCode === alertCode);
            var index = finalArr.findIndex(
              (item) => item.alertCode === alertCode
            );

            if (result === undefined) {
              dispatch(SetDashboardAlertTypeIndex(0));
              dispatch(SetDashboardAlertTypeCode(finalArr[0]["alertCode"]));
              dispatch(SetDashboardTotal(finalArr[0]["alertCount"]));
            } else {
              dispatch(SetDashboardTotal(result["alertCount"]));
              dispatch(SetDashboardAlertTypeIndex(index));
            }
          }
        } else {
          dispatch(SetDashboardAlertTypeCode(finalArr[0]["alertCode"]));
          dispatch(SetDashboardTotal(finalArr[0]["alertCount"]));
        }
      } else {
        if (res.responseStatus.code === -2) dispatch(SetSessionExpired(true));
        dispatch(SetDashboardTotal(newArr[0]["alertCount"]));
        setAlertTypeList({
          list: [],
          responseStatus: {
            code: res.responseStatus.code,
            msg: res.responseStatus.msg,
          },
        });
      }
    });
  }

  function getListOfBatteries() {
    let queryParams = decryptTheParams();
    listOfBatteries.responseStatus.code !== -1 &&
      setListOfBatteries({
        batteries: [],
        responseStatus: { code: -1, msg: "" },
      });
    if (alertCode === "") {
      setListOfBatteries({
        batteries: [],
        responseStatus: {
          code: alertTypeList.responseStatus.code,
          msg: "No Data Found",
        },
      });
    } else {
      alertTypeList.responseStatus.code !== -1 &&
        getTableBatteries(
          tabvalue,
          alertCode,
          volt,
          category,
          city,
          zone,
          batterystatus,
          severity,
          iotVendor,
          packVendor,
          priority,
          batteryID,
          partner,
          reduxStartDate,
          reduxEndDate,
          pageNumber,
          sortChangedTo[tabvalue]["sortBy"],
          orderChangedTo,
          rowsPerPage,
          props.pagesContent.batteryType,
          queryParams
        ).then((res) => {
          if (res.responseStatus.code === 200) {
            setListOfBatteries({
              batteries: res.response.alertList,
              responseStatus: {
                code: res.responseStatus.code,
                msg: res.responseStatus.msg,
              },
            });

            if (batteryID !== "") {
              let temp;
              temp = {
                ...queryParams,
                deviceID: res.response.alertList[0]["batteryID"],
                type: "Device",
              };
              encryptTheParams(temp, navigate);
            }
          } else {
            if (res.responseStatus.code === -2)
              dispatch(SetSessionExpired(true));

            setListOfBatteries({
              batteries: [],
              responseStatus: {
                code: res.responseStatus.code,
                msg: res.responseStatus.msg,
              },
            });
          }
        });
    }
    setMounted(true);
  }

  function FilterBox() {
    return (
      <>
        <Grid container spacing={1} sx={{ alignItems: "center" }}>
          <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <GenericSelectRedux
                filter={props.pagesContent.searchTypeFilter}
                handleSetFilter={handleSetSelect}
                selected={batteryPartnerSelect}
                maxWidth={"max-content"}
                showClearButton={false}
                id="batteryState"
              />
              <AutocompleteDashboard
                width={300}
                resetTheFilters={resetTheFilters}
                tabValue={tabvalue}
                alertCode={props.pagesContent.alertType.find(
                  (o) => o.itemName === "All"
                )}
                page={"Dashboard"}
                openNotification={openNotification}
              />
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={9}
            xl={9}
            sx={{
              display: "flex",
              justifyContent: {
                xs: "flex-start",
                sm: "flex-start",
                md: "flex-start",
                lg: "flex-end",
                xl: "flex-end",
              },
            }}
          >
            <Box className="filterDateRange">
              <Box sx={{ display: "flex" }}>
                {resetButton && batteryID === "" && (
                  <Button
                    sx={{ fontSize: "12px", height: "30px", mt: 1.5, mr: 0.5 }}
                    onClick={() => resetTheFilters()}
                  >
                    Reset
                  </Button>
                )}

                {[
                  {
                    itemName: "Severity",
                    items: [
                      {
                        value: "Super Critical",
                        id: "4",
                      },
                      {
                        value: "Critical",
                        id: "3",
                      },
                      {
                        value: "High",
                        id: "2",
                      },
                      {
                        value: "Low",
                        id: "1",
                      },
                    ],
                  },
                  {
                    itemName: "Status",
                    items: [
                      {
                        value: "Idle",
                        id: "0",
                      },
                      {
                        value: "Charging",
                        id: "4",
                      },
                      {
                        value: "Discharging",
                        id: "2",
                      },
                    ],
                  },
                  {
                    itemName: "City",
                    items: [
                      {
                        value: "Delhi",
                        id: "delhi",
                      },
                      {
                        value: "Faridabad",
                        id: "faridabad",
                      },
                      {
                        value: "Ghaziabad",
                        id: "ghaziabad",
                      },
                      {
                        value: "Gurgaon",
                        id: "gurgaon",
                      },
                      {
                        value: "Jaipur",
                        id: "jaipur",
                      },
                      {
                        value: "Kanpur",
                        id: "Kanpur",
                      },
                      {
                        value: "Karnal",
                        id: "Karnal",
                      },
                      {
                        value: "Lucknow",
                        id: "Lucknow",
                      },
                      {
                        value: "Meerut",
                        id: "Meerut",
                      },
                      {
                        value: "Noida",
                        id: "Noida",
                      },
                      {
                        value: "Panipat",
                        id: "Panipat",
                      },
                      {
                        value: "Sonipat",
                        id: "Sonipat",
                      },
                    ],
                  },
                  {
                    itemName: "Zone",
                    items: [
                      {
                        value: "Mayur Vihar",
                        id: "Mayur Vihar",
                      },
                      {
                        value: "Noida",
                        id: "Noida",
                      },
                      {
                        value: "South Delhi",
                        id: "South Delhi",
                      },
                      {
                        value: "Jankapuri Kirtinagar",
                        id: "Jankapuri Kirtinagar",
                      },
                      {
                        value: "Rohini",
                        id: "Rohini",
                      },
                      {
                        value: "Jahagirpuri",
                        id: "Jahagirpuri",
                      },
                      {
                        value: "Bawana",
                        id: "Bawana",
                      },
                      {
                        value: "Central Delhi",
                        id: "Central Delhi",
                      },
                      {
                        value: "Faridabad",
                        id: "Faridabad",
                      },
                      {
                        value: "Shahadra",
                        id: "Shahadra",
                      },
                      {
                        value: "Anand Vihar",
                        id: "Anand Vihar",
                      },
                      {
                        value: "Gurgaon",
                        id: "Gurgaon",
                      },
                    ],
                  },
                  {
                    itemName: "IOT",
                    items: [
                      {
                        value: "Wynncom",
                        id: "Wynncom",
                      },
                      {
                        value: "Intellicar",
                        id: "Intellicar",
                      },
                    ],
                  },
                  {
                    itemName: "Pack",
                    items: [
                      {
                        value: "Livguard",
                        id: "livguard",
                      },
                    ],
                  },
                ].map(({ itemName, items }, index) => {
                  return (
                    <Box key={index}>
                      <GenericMultipleSelect
                        label={itemName}
                        options={items}
                        maxWidth={"100px"}
                        optionValue={filters2[itemName]}
                        handleSetFilter={handleSetFilter}
                        id="overflow-text-3"
                      />
                    </Box>
                  );
                })}
              </Box>
            </Box>
          </Grid>
        </Grid>
        {/* 
          </Box>
          {/* <ConfigProvider
            theme={{
              token: {
                colorPrimary: ThemeProperties.purple,
              },
            }}
          >
            <Dropdown
              menu={{
                items,
              }}
              className="dropDowndDiv"
              // disabled
              open={open}
              onOpenChange={handleOnOpenChange}
              trigger={["click"]}
              dropdownRender={(menu) => (
                <div>
                  <div className="dropDown" style={contentStyle}>
                    <div className="dropDownTop">
                      <Typography variant="tableHead">
                        Select columns to show
                      </Typography>
                    </div>

                    <div className="dropDownMiddle">
                      {React.cloneElement(menu, {
                        style: menuStyle,
                      })}
                    </div>

                    <div className="dropDownBottom">
                      <AntButton onClick={() => onClickReset()}>
                        Reset
                      </AntButton>
                      <AntButton type="primary" onClick={() => onClickApply()}>
                        Apply
                      </AntButton>
                    </div>
                  </div>
                </div>
              )}
            >
              <Space>
                <Avatar
                  variant="square"
                  sx={{
                    bgcolor: "white",
                    border: "1px solid #cecece",
                    borderRadius: "4px",
                    width: 35,
                    height: 35,
                    mt: 0.5,
                    ml: 1,
                  }}
                >
                  <ViewWeekOutlinedIcon
                    onClick={handleOpenChange}
                    sx={{
                      cursor: "pointer",
                      fontSize: "25px",
                      color:
                        newColumns[tabvalue]["columns"].filter(
                          (item) => item.hidden === true
                        ).length > 0
                          ? ThemeProperties.purple
                          : ThemeProperties.greyTextColor,
                    }}
                  />
                </Avatar>
              </Space>
            </Dropdown>
          </ConfigProvider>
        </Box>*/}
      </>
    );
  }

  function showResetButton() {
    // console.log(city,batterystatus,zone,severity,iotVendor,packVendor)
    // console.log(city !== newCity,batterystatus !== newStatus,zone !== newZone,severity !== newSeverity,iotVendor !== newIOT,packVendor !== newPack)

    // console.log(areArraysEqual(city,newCity))
    if (
      !areArraysEqual(city, newCity) ||
      !areArraysEqual(batterystatus, newStatus) ||
      !areArraysEqual(zone, newZone) ||
      !areArraysEqual(severity, newSeverity) ||
      !areArraysEqual(iotVendor, newIOT) ||
      !areArraysEqual(packVendor, newPack)

      // zone !== newZone ||
      // severity !== newSeverity ||
      // iotVendor !== newIOT ||
      // packVendor !== newPack
    ) {
      setResetButton(true);
    } else {
      setResetButton(false);
    }
  }

  useEffect(() => {
    getConnectedBatteries().then((res) => {
      if (res.responseStatus.code === 200) {
        setConnectedBatteries(res.response.data[0]["count"]);
      } else if (res.responseStatus.code === -2) {
        dispatch(SetSessionExpired(true));
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.pagesContent.batteryType]);

  const SetTheAlertTypeList = (data) => {
    let obj =
      category === ""
        ? props.pagesContent.alertType.find((o) => o.itemName === "All")
        : props.pagesContent.alertType.find((o) => o.itemName === category);
    let newArr = obj.items;

    if (data.responseStatus.code === 200) {
      let finalArr = [];
      newArr.forEach((item, index) => {
        let tempObj = data.response.alertList.find(
          (o) => o.alertCode === item.alertCode
        );
        item.alertCount = tempObj === undefined ? 0 : tempObj.alertCount;
      });

      finalArr = newArr.filter((item) => item["alertCount"] > 0);

      console.log(finalArr);
      console.log(newArr);

      setAlertTypeList({
        list: finalArr,
        responseStatus: {
          code: data.responseStatus.code,
          msg: data.responseStatus.msg,
        },
      });
      if (alertCode !== "") {
        if (indexDashboardAlertType === 0) {
          if (finalArr[0]["alertCode"] !== alertCode) {
            console.log("one");
            dispatch(SetDashboardAlertTypeCode(finalArr[0]["alertCode"]));
            dispatch(SetDashboardTotal(finalArr[0]["alertCount"]));
          } else {
            console.log("two");

            dispatch(SetDashboardTotal(finalArr[0]["alertCount"]));
          }
        } else {
          var result = finalArr.find((item) => item.alertCode === alertCode);
          var index = finalArr.findIndex(
            (item) => item.alertCode === alertCode
          );

          if (result === undefined) {
            dispatch(SetDashboardAlertTypeIndex(0));
            dispatch(SetDashboardAlertTypeCode(finalArr[0]["alertCode"]));
            dispatch(SetDashboardTotal(finalArr[0]["alertCount"]));
            console.log("three");
          } else {
            dispatch(SetDashboardTotal(result["alertCount"]));
            dispatch(SetDashboardAlertTypeIndex(index));
            console.log("four");
          }
        }
      } else {
        dispatch(SetDashboardAlertTypeCode(finalArr[0]["alertCode"]));
        dispatch(SetDashboardTotal(finalArr[0]["alertCount"]));
      }
    } else {
      if (data.responseStatus.code === -2) dispatch(SetSessionExpired(true));
      dispatch(SetDashboardTotal(newArr[0]["alertCount"]));
      setAlertTypeList({
        list: [],
        responseStatus: {
          code: data.responseStatus.code,
          msg: data.responseStatus.msg,
        },
      });
    }
  };

  useEffect(() => {
    // getALertType();

    let queryParams = decryptTheParams();
    alertTypeList.responseStatus.code !== -1 &&
      setAlertTypeList({
        list: [],
        responseStatus: { code: -1, msg: "" },
      });

    const controller = new AbortController();

    const getAlertTypeList = async () => {
      let alertState =
        tabvalue === 0
          ? "Active"
          : tabvalue === 1
          ? "Open"
          : tabvalue === 2
          ? "Resolved"
          : tabvalue === 3
          ? "Ignored"
          : "Expired";

      let newDeviceID, newBatteryID;
      if (queryParams && queryParams["type"] === "Device") {
        newDeviceID = queryParams["deviceID"];
        newBatteryID = "";
      } else if (queryParams && queryParams["type"] === "Battery") {
        newDeviceID = "";
        newBatteryID = batteryID;
      } else {
        newDeviceID = "";
        newBatteryID = "";
      }
      var rawJson = {
        location: areArraysEqual(city, newCity) ? [] : city,
        zone: areArraysEqual(zone, newZone) ? [] : zone,
        voltConf: "",
        alertCode: "",
        batteryStatus: areArraysEqual(batterystatus, newStatus)
          ? []
          : batterystatus,
        severity: areArraysEqual(severity, newSeverity) ? [] : severity,
        iotVendor: areArraysEqual(iotVendor, newIOT) ? [] : iotVendor,
        batteryVendor: areArraysEqual(packVendor, newPack) ? [] : packVendor,
        priority: priority,
        alertState: alertState,
        batteryState: "",
        alertType: category,
        startDate:
          reduxStartDate === ""
            ? reduxStartDate
            : convertZonetoUTCStart(reduxStartDate),
        endDate:
          reduxEndDate === ""
            ? reduxEndDate
            : convertZonetoUTCEnd(reduxEndDate),
        assetID: newBatteryID,
        batteryID: newDeviceID,
        partner: partner,
        batteryType: props.pagesContent.batteryType,
        batteryFlag: [0],
      };

      try {
        let res = await axios.get(`/api/alert_group_count/v2`, {
          params: rawJson,
          paramsSerializer: (params) =>
            qs.stringify(params, { arrayFormat: "repeat" }),
          headers: {
            "Content-Type": "application/json",
          },
          signal: controller.signal,
        });
        const data = callTheAPI(res);
        SetTheAlertTypeList(data);
      } catch (error) {
        if (error.response?.status === CODE.URL_NODATA) {
          setAlertTypeList({
            ...alertTypeList,
            responseStatus: {
              code: CODE.NODATA,
              msg: "No Data",
            },
          });
        } else if (error.response?.status === CODE.FORBIDDEN) {
          setAlertTypeList({
            ...alertTypeList,
            responseStatus: {
              code: CODE.NODATA,
              msg: "No Data",
            },
          });
        } else if (error.response?.status === CODE.UNAUTHORIZED) {
          dispatch(SetRefreshAPICalled(false));

          try {
            let refresh = await axios.get("/api/refresh");
            if (refresh && refresh.status === CODE.SUCCESS) {
              dispatch(SetRefreshAPICalled(true));
              try {
                let res = await axios.get(`/api/alert_group_count/v2`, {
                  params: rawJson,
                  headers: {
                    "Content-Type": "application/json",
                  },
                  signal: controller.signal,
                });
                const data = callTheAPI(res);
                SetTheAlertTypeList(data);
              } catch (error) {
                if (error.response.status === CODE.URL_NODATA) {
                  setAlertTypeList({
                    ...alertTypeList,
                    responseStatus: {
                      code: CODE.NODATA,
                      msg: "No Data",
                    },
                  });
                } else if (error.response.status === CODE.UNAUTHORIZED) {
                  // removeAccessToken();
                  return null;
                }
              }
            }
          } catch (error) {
            // Logout();
            SetSessionExpired();
          }
        }
      }
      //   let data = GetData(config);
      //   return data;
    };
    if (
      severity.length > 0 &&
      batterystatus.length > 0 &&
      city.length > 0 &&
      zone.length > 0 &&
      iotVendor.length > 0 &&
      packVendor.length > 0
    )
      getAlertTypeList();
      else
      {
        setAlertTypeList({
          list: [],
          responseStatus: { code: 404, msg: "" },
        });
      }

    showResetButton();
    return () => {
      controller.abort();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    tabvalue,
    volt,
    category,
    city,
    zone,
    batterystatus,
    severity,
    iotVendor,
    packVendor,
    reduxStartDate,
    reduxEndDate,
    batteryID,
    deviceID,
    partner,
    props.pagesContent.batteryType,
    // batteryPartnerSelect
  ]);

  useEffect(() => {
    setMounted(false);
    const tempColumns = [...newColumns];
    const newOrderChangedTo = orderChangedTo === "desc" ? "descend" : "ascend";
    tempColumns[tabvalue]["columns"].forEach((column, i) => {
      if (
        column.key === sortChangedTo[tabvalue]["sortBy"] &&
        column.sorter === true
      ) {
        column.defaultSortOrder = newOrderChangedTo;
      } else {
        column.defaultSortOrder = "";
      }
    });
    dispatch(SetDashboardColumns(tempColumns));

    if (
      severity.length > 0 &&
      batterystatus.length > 0 &&
      city.length > 0 &&
      zone.length > 0 &&
      iotVendor.length > 0 &&
      packVendor.length > 0
    )
    getListOfBatteries();
    else
    {
      setMounted(true);
      setListOfBatteries({
        batteries: [],
        responseStatus: { code: 404, msg: "" },
      });
    }

    // alertCode !== "" && dispatch(SetDashboardPageNumber(1));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    tabvalue,
    alertTypeList,
    alertCode,
    volt,
    category,
    city,
    zone,
    batterystatus,
    severity,
    iotVendor,
    packVendor,
    pageNumber,
    reduxStartDate,
    reduxEndDate,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    sortChangedTo[tabvalue]["sortBy"],
    orderChangedTo,
    batteryID,
    deviceID,
    partner,
    rowsPerPage,
    props.pagesContent.batteryType,
  ]);

  useEffect(() => {
    let itemIDS = [];
    universal.forEach((item) => itemIDS.push(...item.itemIDs));

    setReduxCountItemIds(itemIDS.length);
    SetCountForCart();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [universal]);

  useEffect(() => {
    if (selectedBatteriesAction === "Add") {
      addToCart();
    }
    if (selectedBatteriesAction === "Remove") {
      removeSelection();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedBatteriesAction]);

  useEffect(() => {
    if (batteryID !== "" || partner !== "" || deviceID !== "") {
      openNotification("bottomLeft", "Cleared all filters if selected");
    }
    // showResetButton();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [batteryID, partner, deviceID]);

  return (
    <div>
      <OuterBox>
        <InnerBox>
          <Context.Provider value={contextValue}>
            {contextHolder}
            <PageHeaderKPI
              name={"Alerts"}
              nonClickableKpis={dashboardNonClickablekpis}
              connectedBatteries={connectedBatteries}
            />
            <Box sx={{ mt: 2, position: "relative" }}>
              <Box sx={{ position: "relative" }}>
                <Box sx={{ position: "absolute", right: 9, zIndex: 1 }}>
                  <>
                    <Tooltip
                      placement={"bottom"}
                      title={
                        cartBatteriesCount + reduxCountItemIds > 0
                          ? "Show selected batteries"
                          : "Select some batteries from table to activate"
                      }
                    >
                      <Badge
                        badgeContent={
                          !mountedCartBatteries ? (
                            <CircularProgress size={12} />
                          ) : (
                            cartBatteriesCount + reduxCountItemIds
                          )
                        }
                        max={20000}
                        sx={{
                          "& .MuiBadge-badge": {
                            fontSize: "13px",
                            minHeight: 16,
                            // minWidth: 15,
                            p: 1,
                            border: "1px solid grey",
                            bgcolor: "white",
                            mt: "5px",
                            color: ThemeProperties.purple,
                          },
                        }}
                      >
                        <LayersOutlinedIcon
                          onClick={() => {
                            if (cartBatteriesCount + reduxCountItemIds > 0) {
                              addToCart();
                              handleOpenBatteryStackDialog();
                              Events("clicked Selected Batteries For Action");
                            }
                          }}
                          sx={{
                            fontSize: "20px",
                            cursor:
                              cartBatteriesCount + reduxCountItemIds
                                ? "pointer"
                                : "default",
                            border: `1px solid ${
                              cartBatteriesCount + reduxCountItemIds
                                ? ThemeProperties.purple
                                : ThemeProperties.dark_grey
                            }`,
                            backgroundColor:
                              cartBatteriesCount + reduxCountItemIds
                                ? ThemeProperties.purple
                                : "white",
                            padding: "5px",
                            borderRadius: "50%",
                            margin: "5px 5px 5px",
                            color:
                              cartBatteriesCount + reduxCountItemIds
                                ? ThemeProperties.white
                                : ThemeProperties.dark_grey,
                            //pointerEvents: mapClusterClick ? "auto" : "none",
                            // opacity: cartBatteries + reduxCountItemIds ? 1 : 0.8,
                          }}
                        />
                      </Badge>
                    </Tooltip>
                  </>
                </Box>

                <Box
                  sx={{ position: "absolute", right: 60, zIndex: 1, top: 5 }}
                >
                  <AntDatePicker
                    changeTheDate={changeTheDate}
                    date={[reduxStartDate, reduxEndDate]}
                    allowClear={true}
                  />
                </Box>

                
                  <TabWithColorDashboard
                    ChangeTheTab={ChangeTheTab}
                    tabs={DashboardTabs}
                  />
              

                {DashboardTabs.map((item, index) => (
                  <BasicTabPanel value={tabvalue} index={index} key={index}>
                    <Paper
                      elevation={0}
                      sx={{
                        height: "100%",
                        borderRadius: "0px 12px 12px",
                        p: 1,
                        border: "1px solid #ececec",
                        minWidth: "800px",
                        overflowX: "scroll",
                      }}
                    >
                      {FilterBox()}
                      <hr style={{ borderTop: "1px solid #ececec" }}></hr>
                      <Box sx={{ mt: 1.5 }}>
                        <Grid container spacing={2}>
                          <Grid item xs={4} sm={4} md={4} lg={3} xl={3}>
                            <ListWithSelectionNew
                              data={alertTypeList}
                              // setPageNumber={setPageNumber}
                              batteryType={props.pagesContent.batteryType}
                              handleSetFilter={handleSetFilter}
                              // selected={category} // All,48V,60V

                              alertType={props.pagesContent.alertType}
                              category={category}
                            />
                          </Grid>
                          <Grid item xs={8} sm={8} md={8} lg={9} xl={9}>
                            {mounted && (
                              <BasicTableDashboard
                                data={listOfBatteries}
                                total={total}
                                columns={newColumns}
                                rowSelection={
                                  tabvalue === 0
                                    ? true
                                    : tabvalue === 1
                                    ? true
                                    : false
                                }
                                extraStatus={alertTypeList.responseStatus.code}
                                city={city}
                                zone={zone}
                                volt={volt}
                                category={category}
                                alertCode={alertCode}
                                batterystatus={batterystatus}
                                iotVendor={iotVendor}
                                packVendor={packVendor}
                                severity={severity}
                                tabvalue={tabvalue}
                                priority={priority}
                                batteryState={""}
                                date={[reduxStartDate, reduxEndDate]}
                                batteryID={batteryID}
                                partner={partner}
                                batteryType={props.pagesContent.batteryType}
                                // getALertType={getALertType}
                                // getListOfBatteries={getListOfBatteries}
                                openNotification={openNotification}
                              />
                            )}
                          </Grid>
                        </Grid>
                      </Box>
                    </Paper>
                  </BasicTabPanel>
                ))}
              </Box>
            </Box>
          </Context.Provider>
        </InnerBox>
      </OuterBox>
      {openBatteryStackDialog && (
        <>
          <BatteriesInCart
            // anchorElBatteryStackDialog={anchorElBatteryStackDialog}
            batteries={batteries}
            openBatteryStackDialog={openBatteryStackDialog}
            handleCloseBatteryStackDialog={handleCloseBatteryStackDialog}
            SetCountForCart={SetCountForCart}
            setCartBatteriesCount={setCartBatteriesCount}
            // getALertType={getALertType}
            // getListOfBatteries={getListOfBatteries}
          />
        </>
      )}

      <RemoveSelectedBatteries
        openRemoveSelectedBatteries={openRemoveSelectedBatteries}
        // handleCloseRemoveSelectedBatteries={handleCloseRemoveSelectedBatteries}
        addToCart={addToCart}
        removeSelection={removeSelection}
      />
    </div>
  );
}

export default DashboardMain;

// {props.pagesContent.filtersWithData.map((item, index) => {
//   // if (
//   //   props.pagesContent.filteredArray.includes(item["itemName"])
//   // ) {
//     return (
//       <Box key={index}>
//         <GenericSelectTest
//           filter={item}
//           handleSetFilter={handleSetFilter}
//           selected={filters[item["itemName"]]} // All,48V,60V
//           maxWidth={"100px"}
//           showClearButton={true}
//           id="overflow-text-1"
//           pageName={"Dashboard"}
//           alertType={props.pagesContent.alertType}
//         />
//       </Box>
//     );
//   //}
// })}
